import React from 'react';
import useStyles from "../style";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

const InputSelectMembershipType = ({ text, setValue, label, options, isEnable, isRequired, allDays, setMembershipValidity }) => {
    const classes = useStyles();

    const handleChange = (e) => {
        const value = e.target.value;
        var membershipValidity = '';
        var cost = 0;

        if (value != '') {
            const servicesList = [];
            const allDaysList = [];

            allDays.map((option) => {
                allDaysList.push(option.name);
            });

            options.map((option) => {
                if (option.membershipName == value) {
                    membershipValidity = option.membershipValidity;
                    cost = option.cost;

                    option.services.map((option) => {
                        var servicesItem = {
                            "serviceName": option.serviceName,
                            "numberOfDays": option.numberOfDays,
                            "days": option.numberOfDays == 7 ? allDaysList : [],
                            "isAllSelected": false
                        };

                        servicesList.push(servicesItem);
                    });
                }
            });

            setValue({
                ...text, text: value, membershipValidity: membershipValidity,
                cost: cost, services: servicesList, valid: 'true'
            });
            if (setMembershipValidity != null) {
                setMembershipValidity(membershipValidity);
            }
        } else {
            setValue({ ...text, text: value, membershipValidity: 0, cost: 0, services: [], valid: 'false' });
            if (setMembershipValidity != null) {
                setMembershipValidity(0);
            }
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <FormControl className={classes.formControl}>
                <Select
                    onChange={handleChange}
                    displayEmpty
                    disabled={isEnable ?? false}
                    value={text.text}
                    style={{ color: "#FFFFFF" }}
                >
                    <MenuItem value=""> Selecciona </MenuItem>
                    {options.map((option) => (
                        <MenuItem value={option.membershipName}>{option.membershipName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

export default InputSelectMembershipType;
